<template>
  <span v-if="!isCompleted" style="color:grey">not finished</span>
  <span v-else-if="signum !== null" style="color:darkred">killed by signal ({{ signum }})</span>
  <span v-else-if="rc === 0" style="color:darkgreen">succeeded (0)</span>
  <span v-else>finished ({{ rc }})</span>
</template>

<script>

export default {
  computed: {
    isCompleted: function() {
      return !((this.rc === null || typeof this.rc == 'undefined') && (this.signum === null || typeof this.signum == 'undefined'));
    }
  },
  props: {
    rc: [Number],
    signum: [String]
  }
};
</script>
